<template>
  <div class="w-100">
    <b-input-group class="d-flex flex-nowrap">
      <b-form-input
        class="rounded-10-left"
        readonly
        v-model="value_model"></b-form-input>
      <b-btn
        :id="`copyButton-${id}`"
        @click="copyDataToClipboard(value_model, true)"
        variant="light"
        size="sm"
        class="input-height rounded-10-right">
        <i class="far fa-copy fa-2x text-muted"></i>
      </b-btn>
    </b-input-group>
    <b-tooltip
      :target="`copyButton-${id}`"
      triggers="focus"
      :title="tooltip || $t('global.copied')"
      placement="topright"
      :delay="{show: 0, hide: 800}"
    ></b-tooltip>
  </div>
</template>

<script>
  import {inviteMethods} from '@/mixins/invite';

  export default {
    name: 'InputCopyValue',
    mixins: [inviteMethods],
    props: {
      tooltip: {
        type: String,
        default: ''
      },
      id: {
        type: String,
        default: ''
      },
      value: {
        type: String,
        default: ''
      }
    },
    data () {
      return {
        value_model: ''
      }
    },
    created () {
      this.value_model = this.value
    }
  }
</script>
